(()=>{
  const seen=new WeakSet();
  function init(){document.querySelectorAll('.header.vr-header-lists').forEach(header=>{
    if(seen.has(header))return;seen.add(header);
    const logo=header.querySelector('.header__heading-link .vr-design-wordmark-image');if(!logo)return;
    const desktop=matchMedia('(min-width:990px)');
    const update=()=>{
      const height=desktop.matches?(logo.getBoundingClientRect().height||28):24;
      const value=height.toFixed(3)+'px';
      if(header.style.getPropertyValue('--vr-header-object-height')!==value)header.style.setProperty('--vr-header-object-height',value);
    };
    const observer=new ResizeObserver(update);observer.observe(logo);
    logo.addEventListener('load',update);desktop.addEventListener('change',update);
    document.fonts?.ready.then(update);update();
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
